import React, { useEffect, useRef, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + '/start-here';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const GoogleLoginButton = ({ label = 'Continue with Google' }) => (
  <button
    type="button"
    onClick={startGoogleLogin}
    data-testid="google-login-btn"
    className="w-full flex items-center justify-center gap-3 py-3 rounded-lg border border-divider bg-white text-black font-semibold hover:bg-gray-100 transition-colors"
  >
    <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.3 6.1 29.4 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.6-.4-3.9z"/><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.3 6.1 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.1 5.7l6.2 5.2C36.9 40.4 44 35 44 24c0-1.3-.1-2.6-.4-3.9z"/></svg>
    {label}
  </button>
);

// Handles {redirect}#session_id=... after Google auth, exchanges for our JWT, then enters the app.
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : '';
    if (!sessionId) { window.location.replace('/login'); return; }
    fetch(`${API_URL}/api/auth/google/session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((r) => { if (!r.ok) throw new Error('auth failed'); return r.json(); })
      .then((data) => {
        localStorage.setItem('token', data.token);
        window.location.replace('/start-here');
      })
      .catch(() => setError('Google sign-in failed. Please try again.'));
  }, []);

  return (
    <div className="min-h-screen bg-deep-navy flex items-center justify-center px-4" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-orange font-bold mb-3">{error}</p>
          <a href="/login" className="text-lime hover:underline">Back to login</a>
        </div>
      ) : (
        <p className="text-light-gray">Signing you in…</p>
      )}
    </div>
  );
}
